module.exports = __webpack_public_path__ + "img/pattern3.3cb56dc.svg";